import { colors } from "./theme";
import styled from "@emotion/styled";
export const Paper = styled.div(() => ({
    backgroundColor: colors.white,
    borderRadius: "0.4rem",
    boxShadow: "0 2px 4px 0 hsla(0, 0%, 0%, 0.2)",
    width: "auto",
}));
//# sourceMappingURL=Paper.js.map